import {
  formatDateOnlySite,
  getWeekRange,
} from '../../../../../utils/dateUtil';
import { useTemplatesApptCounts } from '../../../../../hooks/apptTemplate/useTemplatesApptCounts';
import { WeeklyApptCountsCard } from './WeeklyApptCountsCard';

export const TemplateApptCountsCard = ({
  showOnlineMustBeShown,
  selectedDate,
  isLoading,
}: {
  showOnlineMustBeShown: boolean;
  selectedDate: Date;
  isLoading: boolean;
}) => {
  const { fromDate, toDate } = getWeekRange(selectedDate);

  const { isFetching: isTemplateApptsCountFetching, templateCounts } =
    useTemplatesApptCounts({
      fromDate,
      toDate,
    });

  const isFetching = isLoading || isTemplateApptsCountFetching;

  return (
    <WeeklyApptCountsCard
      showOnlineMustBeShown={showOnlineMustBeShown}
      selectedDate={selectedDate}
      isLoading={isFetching}
      templateCounts={templateCounts}
      subtitle={`(${formatDateOnlySite(fromDate)} - ${formatDateOnlySite(
        toDate,
      )})`}
    />
  );
};
